// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-36kSA4vX","sub_logo":"sub_logo-1y7qgE2k","breadcrumbs":"breadcrumbs-3glUPMuU"};